import React from "react";
import homebg from "../img/hero/hero-bg-4.jpg";
import appleStoreBadge from "../img/hero/apple_store_badge.svg";
import shape2 from "../img/hero/shape-2.png";
import shape3 from "../img/hero/shape-3.png";

import taxAssistMockup from "../img/screen/splash-screen-1.png";

const Hero = () => {
    return (
        <>
            <div
                id="apork-hero"
                className="apork-hero-area hero-bg position-relative"
                style={{background: `url('${homebg}')`}}
            >
                <div className="hero-style-shape">
                    <img className="style-shape shape-2" src={shape2} alt="imgshape"/>
                    <img
                        className="style-shape aporkrot shape-3"
                        src={shape3}
                        alt="imgshape"
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-8 col-md-12">
                            <div className="hero-content">
                                <h2>Simplify Your UK Tax Calculations and Tax Returns with AI-Powered Assistant</h2>
                                <p>
                                    Take the hassle out of UK tax calculations with our advanced AI-powered app.
                                    Estimate your annual taxes, manage multiple income streams, and get
                                    expert insights on self-assessment tax returns.
                                </p>
                                <p>
                                    From take-home pay calculations to handling dividends, rental income(for landlords), capital gains,
                                    pensions, and more— our app has you covered.
                                </p>
                                <div className="hero-btn">
                                    <div className="row">
                                        <div className="col-xs-6 col-sm-4">
                                            <a href="https://play.google.com/store/apps/details?id=com.innovotech.taxassistant">
                                                <div className="play-store-badge">
                                                    <img
                                                        alt="Get it on Google Play"
                                                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                                    />
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-xs-6 col-sm-4">
                                            <a href="https://apps.apple.com/app/uk-tax-salary-assist/id6739555013">
                                                <div className="app-store-badge">
                                                    <img alt="Get it on App Store" src={appleStoreBadge} />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 offset-xl-1 col-lg-4 wow fadeInRight">
                            <div className="hero-mobile-img">
                                <img src={taxAssistMockup} alt="UK Tax Assist App Mockup" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;
